import { Grid } from "@mui/material"


import './index'
import { useCallback, useState } from "react";
import ThreeComponent from "../../../components/ThreeColumnsComponent";
import TablePaymentSlips from "../documents/TablePaymentSlips";
import { EMPLOYEE_PAYMENT_SLIPS_ONE, EMPLOYEE_PAYMENT_SLIPS_THREE, EMPLOYEE_PAYMENT_SLIPS_TWO } from "../../../constants/signalRequestConsts";
import MySelectAssignedCompany from "../../../components/MySelectAssignedCompany";

const getDefaultDate = (months: number) => {
    const newDate = new Date();
    newDate.setMonth(newDate.getMonth() + months);
    return newDate;
}

const PaymentSlips = () => {
    const [rucSelected, setRucSelected] = useState<string>("all");

    const ComponentOne = useCallback(() => (
        <TablePaymentSlips
            numberOfCards={1}
            changeViewOptionHidden={true}
            hiddenBottomPaginator={true}
            requestId={EMPLOYEE_PAYMENT_SLIPS_ONE}
            status={2}
            hiddenFilterOptions={false}
            ruc={rucSelected}
        />
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected]);
    
    const ComponentTwo = useCallback(() => (
        <TablePaymentSlips
            numberOfCards={1}
            changeViewOptionHidden={true}
            hiddenBottomPaginator={true}
            startDate={getDefaultDate(-6)}
            requestId={EMPLOYEE_PAYMENT_SLIPS_TWO}
            status={1}
            hiddenFilterOptions={false}
            ruc={rucSelected}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected]);
    
    const ComponentThree = useCallback(() => (
        <TablePaymentSlips
            numberOfCards={1}
            changeViewOptionHidden={true}
            hiddenBottomPaginator={true}
            endDate={getDefaultDate(-6)}
            requestId={EMPLOYEE_PAYMENT_SLIPS_THREE}
            status={1}
            ruc={rucSelected}
        />
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ), [rucSelected]);

    
    return (
        <Grid  container >
            
            <MySelectAssignedCompany
                includeAllCompaniesOption={true}
                allCompaniesOptionValue={"all"}
                setRucSelected={(value) => {
                    setRucSelected(value);
                }} 
                rucSelected={rucSelected}
            />
            <ThreeComponent
                useTabsNameAsTitle={true}
                tabsTitle={["No leídos", "Ultimos 6 meses", "Histórico"]}
                ComponentOne={ComponentOne}
                ComponentTwo={ComponentTwo}
                ComponentThree={ComponentThree}
            />
        </Grid>
    )

}

export default PaymentSlips